/* eslint-disable no-underscore-dangle */
/* eslint-disable new-cap */
// Eslint disabled for variables that are not camelcase
/* eslint-disable camelcase */
const centerPopup = (map, platformPopup, platform) => {
  // find the pixel location on the map where the popup anchor is
  const px = map.project(platformPopup._lngLat);
  if (platform) {
    // find the height of the popup container, divide by 2,
    // subtract from the Y axis of marker location
    px.y -= (platformPopup._container.clientHeight / 2) + 200;
  } else {
    // find the height of the popup container, divide by 2,
    // subtract from the Y axis of marker location
    px.y -= (platformPopup._container.clientHeight / 2);
  }
  map.panTo(map.unproject(px), { animate: true }); // pan to new center
};
// eslint-disable-next-line
export { centerPopup };
